import { render, staticRenderFns } from "./FollowCode.vue?vue&type=template&id=57268a3a&scoped=true&"
import script from "./FollowCode.vue?vue&type=script&lang=js&"
export * from "./FollowCode.vue?vue&type=script&lang=js&"
import style0 from "./FollowCode.vue?vue&type=style&index=0&id=57268a3a&lang=less&scoped=true&"
import style1 from "./FollowCode.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57268a3a",
  null
  
)

export default component.exports